"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    deleteShape: function() {
        return deleteShape;
    },
    flatMarkerArray: function() {
        return flatMarkerArray;
    },
    get: function() {
        return get;
    },
    getById: function() {
        return getById;
    },
    getNextMarkerIndex: function() {
        return getNextMarkerIndex;
    },
    modify: function() {
        return modify;
    }
});
const _enums = require("../enums");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function get(imageInfo = {}) {
    var _imageInfo_ImageInfoKeys_MARKERS;
    return (_imageInfo_ImageInfoKeys_MARKERS = imageInfo[_enums.ImageInfoKeys.MARKERS]) !== null && _imageInfo_ImageInfoKeys_MARKERS !== void 0 ? _imageInfo_ImageInfoKeys_MARKERS : {};
}
function getById(id = "", imageInfo = {}) {
    const markerInfo = get(imageInfo);
    const markerShapes = Object.keys(markerInfo["USERDEFINED"]); // Get all the marker shapes
    // Search for the ID in each marker shape
    for (const shape of markerShapes){
        const marker = markerInfo.USERDEFINED[shape][id];
        if (marker) {
            return {
                shape,
                marker
            };
        }
    }
    return {};
}
function getNextMarkerIndex(type = "", imageInfo = {}) {
    const MARKERS = get(imageInfo);
    const { USERDEFINED = {} } = MARKERS;
    const markerType = _enums.KonvaToRendererShapes[type];
    var _Object_keys;
    const keys = (_Object_keys = Object.keys(USERDEFINED === null || USERDEFINED === void 0 ? void 0 : USERDEFINED[markerType])) !== null && _Object_keys !== void 0 ? _Object_keys : [];
    const count = Math.max(0, keys.length);
    const prefix = _enums.MarkerPrefix[type];
    return `${prefix}${count}`;
}
function modify(shape, imageInfo = {}) {
    // modify MARKERS object with new or modified Marker
    const { id = "", type = "", marker } = shape;
    const markerInfo = get(imageInfo);
    // get marker shape from shape enum
    const markerType = _enums.KonvaToRendererShapes[type];
    // update USERDEFINED MARKERS
    const nextMarkerInfo = _object_spread_props(_object_spread({}, markerInfo), {
        USERDEFINED: _object_spread_props(_object_spread({}, markerInfo.USERDEFINED), {
            [markerType]: _object_spread_props(_object_spread({}, markerInfo.USERDEFINED[markerType]), {
                [id]: _object_spread({}, markerInfo.USERDEFINED[markerType][id], marker)
            })
        })
    });
    return nextMarkerInfo;
}
function deleteShape(shape, imageInfo = {}) {
    const markerInfo = get(imageInfo);
    const { id = "", type = "" } = shape;
    const markerType = _enums.KonvaToRendererShapes[type];
    if (!id || !markerType) {
        // invalid id (marker not found)
        console.error(`Marker ${id} not found with shape ${markerType}`);
        return markerInfo;
    }
    const nextMarkerInfo = _object_spread({}, markerInfo);
    if (nextMarkerInfo.USERDEFINED[markerType]) {
        delete nextMarkerInfo.USERDEFINED[markerType][id];
    } else {
        // Handle the case when USERDEFINED[shape] is not defined
        console.warn(`Invalid Marker shape: ${markerType}`);
    }
    return nextMarkerInfo;
}
function getShapeFromMarker(markerObject = {}, formatTemperature = null) {
    const { characteristics } = markerObject;
    const { markerLabel: label, markerName: name, markerEnabledFlag: isVisible, markerTempC_Max: maxTemp, markerTempC_Min: minTemp, markerTempC_Average: avgTemp } = characteristics;
    let pointsArray = [];
    let labelPrimary = ""; // name or userdefined label
    let labelSecondary = ""; // optional temperature label
    // helper function called by each shape candidate -->
    const processPoints = (points = [])=>{
        const tempMax = formatTemperature(maxTemp !== null && maxTemp !== void 0 ? maxTemp : avgTemp);
        labelPrimary = label || name;
        if (points.length > 1) {
            const tempMin = formatTemperature(minTemp);
            labelSecondary = `Max: ${tempMax}\nMin: ${tempMin}`;
        } else {
            labelSecondary = `${tempMax}`;
        }
        points.forEach((point)=>{
            pointsArray.push({
                x: point === null || point === void 0 ? void 0 : point.X,
                y: point === null || point === void 0 ? void 0 : point.Y
            });
        });
    };
    // is shape candidate a valid POINT? -->
    const point = markerObject[_enums.RendererCoordinates.POINT];
    if (point) processPoints([
        point
    ]);
    // is shape candidate a valid LINE? -->
    const start = markerObject[_enums.RendererCoordinates.START];
    const finish = markerObject[_enums.RendererCoordinates.FINISH];
    if (start && finish) processPoints([
        start,
        finish
    ]);
    // is shape candidate a valid RECTANGLE OR ELLIPSE? -->
    const UL = markerObject[_enums.RendererCoordinates.UPPER_LEFT];
    const LR = markerObject[_enums.RendererCoordinates.LOWER_RIGHT];
    if (UL && LR) processPoints([
        UL,
        LR
    ]);
    // is shape candidate a valid POLYGON? -->
    const points = markerObject[_enums.RendererCoordinates.POINTS];
    if (points) processPoints(points);
    return {
        label: labelPrimary,
        labelSecondary,
        points: pointsArray,
        isVisible: !!isVisible
    };
}
function flatMarkerArray(MARKERS = {}, formatTemperature = null, toDisplayCoordinates = null) {
    /**
   * Returns:       flat array of marker objects
   * Return Value:  [{type, id, data}, ...]
   * Note:          supports optional ordering
   */ const { STANDARD = {}, USERDEFINED = {} } = MARKERS;
    // STANDARD MARKERS
    const standardMarkers = Object.entries(STANDARD).map(([markerName, markerObject])=>{
        const shape = getShapeFromMarker(markerObject, formatTemperature);
        const points = shape.points.map(toDisplayCoordinates);
        return {
            id: markerName,
            name: markerName,
            className: "marker",
            type: _enums.RendererToKonvaShapes[markerName],
            isStandard: true,
            isVisible: shape.isVisible,
            label: shape.label,
            labelSecondary: shape.labelSecondary,
            points
        };
    });
    // USERDEFINED MARKERS
    const userdefinedMarkers = Object.entries(USERDEFINED).flatMap(([markerType, markers])=>Object.entries(markers).map(([uniqueIDString, markerObject])=>{
            var _markerObject_characteristics;
            const shape = getShapeFromMarker(markerObject, formatTemperature);
            const points = shape.points.map(toDisplayCoordinates);
            return {
                className: "marker",
                id: uniqueIDString,
                name: markerObject === null || markerObject === void 0 ? void 0 : (_markerObject_characteristics = markerObject.characteristics) === null || _markerObject_characteristics === void 0 ? void 0 : _markerObject_characteristics.markerName,
                type: _enums.RendererToKonvaShapes[markerType],
                isStandard: false,
                isVisible: shape.isVisible,
                label: shape.label,
                labelSecondary: shape.labelSecondary,
                points
            };
        }));
    return [
        ...standardMarkers,
        ...userdefinedMarkers
    ];
}
const markersHandler = {
    get,
    getById,
    modify,
    deleteShape
};
const _default = markersHandler;
